import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  exclusive: true,
  panelBgColor: 'var(--color-white)',
  panelTitleTextColor: 'var(--color-primary)',
  panelContentTextColor: 'var(--color-text)',
  panelIconColor: 'var(--color-secondaryLight)',
  activePanelBgColor: 'var(--color-greyLight)',
  activePanelTitleTextColor: 'var(--color-primary)',
  activePanelIconColor: 'var(--color-primary)',
  activePanelContentBgColor: 'var(--color-white)',
	items: [
    {
      title: 'Images made for you', 
      content: 'With some optional subtext',
      id: 'sample-id'
    }
  ]
}
 